import {
  success40
} from 'styles/colors.scss';

export default {
  40: success40,
  main: success40
};
